<template>
  <div class="page-wrapper">
    <div :class="['header-wrap style1', { sticky: isSticky }]">
      <div class="header-top">
        <div class="container">
          <TopHeader />
        </div>
      </div>
      <MainNavbarPages />
    </div>

    <div class="content-wrapper">
      <div class="service-details-wrap ptb-50">
        <div class="container">
          <div class="row">
            <div class="col-xl-4 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2">
              <SideBar />
            </div>

            <div class="col-xl-8 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1">
              <div class="service-desc">

                <!-- Header Doctor (Nume, Buton, Poză) -->
                <div class="row">
                  <div class="col-md-9">
                    <h2>Dr. Raluca Roman – Medic specialist neurolog</h2>
                    <div class="other-option md-none mt-40">
                      <a href="/#appointment" class="btn style2">
                        Solicită o programare
                      </a>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="team-card style3">
                      <div class="team-img">
                        <img src="../../../assets/images/team/member-3.jpg" alt="Dr. Raluca Roman – Neurologie" />
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Descriere generală -->
                <p>
                  Sunt <strong>Dr. Raluca Roman</strong>, medic specialist neurolog, cu experiență în diagnosticarea și tratamentul afecțiunilor sistemului nervos central și periferic. Am absolvit Universitatea de Medicină și Farmacie „Gr. T. Popa” din Iași, unde mi-am desfășurat și pregătirea în rezidențiat în cadrul Spitalului Clinic de Urgență „Prof. Dr. N. Oblu”.
                </p>
                <p>
                  De-a lungul parcursului profesional, am dobândit experiență atât în sistemul medical din România, cât și în cel din Franța, în cadrul CHU Nîmes – Departamentul de Neurologie, beneficiind de expunere la practici medicale moderne și abordări multidisciplinare. Sunt în prezent doctorand în Neurologie și am urmat cursuri de specializare în patologia mișcărilor anormale și Boala Parkinson în cadrul Universității Sorbona din Paris.
                </p>
                <p>
                  Consider relația medic–pacient un element esențial al actului medical, oferind explicații clare și sprijin constant pe tot parcursul evaluării și tratamentului, cu obiectivul de a reda pacienților siguranța și încrederea în propriul parcurs terapeutic.
                </p>

                <!-- Arii de interes / Servicii -->
                <h3>Arii de interes și servicii medicale</h3>
                <ul class="content-feature-list style5 list-style">
                  <li>
                    <i class="ri-check-double-line"></i>Diagnosticul și managementul cefaleei și migrenei
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Tulburări de mișcare (tremor, Boala Parkinson și alte sindroame parkinsoniene)
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Afecțiuni neurodegenerative și tulburări cognitive
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Patologie cerebrovasculară și prevenție AVC
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Neuropatii periferice și tulburări de sensibilitate
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Evaluarea simptomelor complexe (amețeli, slăbiciune musculară, amorțeli)
                  </li>
                </ul>

                <!-- Experiență profesională -->
                <h3>Experiență profesională</h3>
                <ul class="content-feature-list style5 list-style">
                  <li>
                    <i class="ri-check-double-line"></i>
                    2024 – prezent: Medic Specialist Neurologie
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>
                    2021 – 2024: Medic Rezident Neurologie, Spitalul Clinic de Urgență „Prof. Dr. N. Oblu”, Iași
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>
                    2021 (mai – noiembrie): Medic Rezident Neurologie, CHU Nîmes, Departamentul de Neurologie, Nîmes, Franța
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>
                    2019 – 2021: Medic Rezident Neurologie, Spitalul Clinic de Urgență „Prof. Dr. N. Oblu”, Iași
                  </li>
                </ul>

                <!-- Educație și formare profesională -->
                <h3>Educație și formare profesională</h3>
                <p>
                  Pregătirea continuă și actualizarea cunoștințelor medicale constituie o prioritate în activitatea mea clinică și cercetare.
                </p>
                <ul class="content-feature-list style5 list-style">
                  <li>
                    <i class="ri-check-double-line"></i>
                    2025: Curs de ecografie carotidiană și al arterelor vertebrale (ABC vascular)
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>
                    2025: Curs – Spasticitate Post-AVC: diagnostic, management terapeutic, monitorizare
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>
                    2025: Curs – Tulburarea neurocognitivă asociată bolii de vase mici cerebrale
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>
                    2024: Curs – Injectare de toxină botulinică, UMF „Carol Davila”, București
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>
                    2024: Curs – Spectrul bolii neuromielita optică (NMO): Actualități de diagnostic și tratament
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>
                    2024: Curs Postuniversitar – Sistemul Vestibular: întrebări și răspunsuri
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>
                    2024: Curs – Cefaleea, actualități în practica medicală
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>
                    2023 – prezent: Doctorand în Neurologie, UMF „Gr. T. Popa”, Iași
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>
                    2022 – 2023: Curs Postuniversitar – Mișcări anormale și patologia mișcării, Universitatea Sorbona, Paris
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>
                    2022 – 2024: Master Managementul serviciilor de sănătate în domeniul medico-farmaceutic, UMF „Gr. T. Popa”, Iași
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>
                    2012 – 2018: Diplomă de Medic, UMF „Gr. T. Popa”, Iași
                  </li>
                </ul>

                <!-- Apartenență la asociații profesionale -->
                <h3>Apartenență la asociații profesionale</h3>
                <ul class="content-feature-list style5 list-style">
                  <li>
                    <i class="ri-check-double-line"></i>Membru al Societății Române de Neurologie (SNR)
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Membru al Academiei Europene de Neurologie (EAN)
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Membru al Societății Internaționale pentru Boala Parkinson și Tulburări de Mișcare (MDS)
                  </li>
                </ul>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <MainFooter />
  </div>
</template>

<script>
import TopHeader from "../../Layouts/TopHeader.vue";
import MainNavbarPages from "../../Layouts/MainNavbarPages.vue";
import SideBar from "./SideBar.vue";
import MainFooter from "../../Layouts/MainFooter.vue";

import { defineComponent } from "vue";

export default defineComponent({
  name: "RalucaRomanPage",
  components: {
    TopHeader,
    SideBar,
    MainNavbarPages,
    MainFooter,
  },
  data() {
    return {
      isSticky: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      let scrollPos = window.scrollY;
      if (scrollPos >= 100) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    });
  },
});
</script>